import { ProcedureStepReviewerService as OvermapProcedureStepReviewerService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepReviewerService extends OvermapProcedureStepReviewerService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
